import styled from 'styled-components';
import { media } from '../../common/MediaQueries';

export const JobTimeWrapper = styled.div`
  display: none;

  @media ${media.desktop} {
    display: flex;
    align-items: flex-end;
    margin-top: 7px;
    min-height: 38px;
  }
`;
